import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/sys/channel/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/sys/channel/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/sys/channel/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/sys/channel/submit',
    method: 'post',
    data: row
  })
}
